// FEATURED COLLECTION (namespace .s-featured)
// - Quick add com fetch
// - Abertura instantânea do cart drawer (Halo)
// - Proteção contra duplicação (LOCK GLOBAL)

(function () {

  // 🔒 LOCK GLOBAL — impede add duplicado por race condition
  if (window.__FEATURED_QUICK_ADD_LOADED__) return;
  window.__FEATURED_QUICK_ADD_LOADED__ = true;

  window.__FEATURED_ADD_IN_PROGRESS__ = false;

  function openCartDrawer() {
    var openBtn =
      document.querySelector('[data-open-cart-sidebar]') ||
      document.querySelector('[data-cart-toggle]');

    if (openBtn) {
      openBtn.click();
      return;
    }

    // Fallback mínimo
    document.body.classList.add('open-cart-sidebar');
  }

  function initQuickAdd(section) {
  var forms = section.querySelectorAll('.s-featured__quick-add-form');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var submitButton = form.querySelector('[data-quick-add-button]');
    if (!submitButton) return;

    var label = submitButton.querySelector('.s-featured__cta-label');
    var defaultLabel = label ? label.textContent : 'Comprar';

    function setLoading() {

      submitButton.classList.add('is-loading');

      var isMobileGrid =
        window.innerWidth < 768 &&
        section &&
        !section.classList.contains('s-featured--carousel');

      if (!isMobileGrid && label) {
        label.textContent = 'Adicionando...';
      }
    }

    function resetLoading() {
      submitButton.classList.remove('is-loading');

      if (label) {
        label.textContent = defaultLabel;
      }
    }

    form.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    submitButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (submitButton.classList.contains('is-loading')) return;
      if (window.__FEATURED_ADD_IN_PROGRESS__) return;

      window.__FEATURED_ADD_IN_PROGRESS__ = true;

      if (!window.fetch) {
        window.__FEATURED_ADD_IN_PROGRESS__ = false;
        return;
      }

      var formData = new FormData(form);
      var variantId = formData.get('id');

      if (!variantId) {
        console.error('[FEATURED] Variant ID inválido');
        window.__FEATURED_ADD_IN_PROGRESS__ = false;
        return;
      }

      // 🔥 loading instantâneo + drawer
      setLoading();
      openCartDrawer();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(
                (data && (data.description || data.message)) ||
                'Erro ao adicionar produto ao carrinho.'
              );
            });
          }

          return res.json();
        })
        .then(function () {
          if (typeof Shopify !== 'undefined' && Shopify.getCart) {
            Shopify.getCart(function (cart) {
              if (typeof window.updateCart === 'function') {
                window.updateCart(cart);
              }
            });
          }
        })
        .catch(function (err) {
          console.error('[FEATURED] Erro no quick add:', err);
        })
        .finally(function () {
          resetLoading();
          window.__FEATURED_ADD_IN_PROGRESS__ = false;
        });
    });
  });
}

  function initReveal(section) {
    if (!section.classList.contains('s-featured--reveal')) return;

    if (!('IntersectionObserver' in window)) {
      section.querySelectorAll('.s-featured__card').forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    section.querySelectorAll('.s-featured__card').forEach(function (card) {
      observer.observe(card);
    });
  }

  function initCouponCopy(section) {
    const buttons = section.querySelectorAll('.s-featured__coupon-badge');
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      const codeEl = btn.querySelector('.s-featured__coupon-code');
      const originalCode = codeEl ? codeEl.textContent : '';

      btn.addEventListener('click', () => {
        const coupon = btn.getAttribute('data-coupon');
        if (!coupon) return;

        navigator.clipboard.writeText(coupon).then(() => {
          btn.classList.add('is-copied');

          const labelEl = btn.querySelector('.s-featured__coupon-label');

          if (labelEl) {
            labelEl.textContent = 'CUPOM';
          }

          if (codeEl) {
            codeEl.textContent = 'COPIADO';
          }

          setTimeout(() => {
            btn.classList.remove('is-copied');

            if (labelEl) {
              labelEl.textContent = 'CUPOM';
            }

            if (codeEl) {
              codeEl.textContent = originalCode;
            }
          }, 2000);
        });
      });
    });
  }  

// ==============================
// CARROSSEL DESKTOP – NAVEGAÇÃO
// ==============================
function updateFeaturedNav(section) {
  if (window.innerWidth < 1024) return;

  var list = section.querySelector('.s-featured__list');
  var cards = section.querySelectorAll('.s-featured__card');

  var prevBtn = section.querySelector('.s-featured__nav-btn.is-prev');
  var nextBtn = section.querySelector('.s-featured__nav-btn.is-next');

  if (!list || !prevBtn || !nextBtn) return;

  var cardsPerView = 4;

  if (cards.length <= cardsPerView) {
    prevBtn.style.visibility = 'hidden';
    nextBtn.style.visibility = 'hidden';
    return;
  }

  var maxScrollLeft = list.scrollWidth - list.clientWidth;
  var currentScroll = Math.round(list.scrollLeft);

  var isAtStart = currentScroll < 30;
  var isAtEnd = currentScroll >= maxScrollLeft - 30;

  if (isAtStart) {
    prevBtn.style.visibility = 'hidden';
    nextBtn.style.visibility = 'visible';
    return;
  }

  if (isAtEnd) {
    prevBtn.style.visibility = 'visible';
    nextBtn.style.visibility = 'hidden';
    return;
  }

  prevBtn.style.visibility = 'visible';
  nextBtn.style.visibility = 'visible';
}

// =====================================
// LAZY LOAD DA SEGUNDA IMAGEM
// =====================================

function initSecondaryImages(section) {

  if (window.innerWidth < 768) return;

  if (!('IntersectionObserver' in window)) return;

  var cards = section.querySelectorAll('.s-featured__card');

  if (!cards.length) return;

  var observer = new IntersectionObserver(function(entries) {

    entries.forEach(function(entry) {

      if (!entry.isIntersecting) return;

      var card = entry.target;

      var media = card.querySelector('.s-featured__media');

      var template = card.querySelector('.s-featured__secondary-template');

      if (!media || !template) {
        observer.unobserve(card);
        return;
      }

      // evita duplicação
      if (!media.querySelector('.s-featured__image--secondary')) {

        media.insertAdjacentHTML(
          'beforeend',
          template.innerHTML
        );

      }

      observer.unobserve(card);

    });

  }, {
    rootMargin: '200px'
  });

  cards.forEach(function(card) {
    observer.observe(card);
  });

}

function initCarouselNav(section) {

  var prevBtn = section.querySelector('.s-featured__nav-btn.is-prev');
  var nextBtn = section.querySelector('.s-featured__nav-btn.is-next');
  var list = section.querySelector('.s-featured__list');

  if (!prevBtn || !nextBtn || !list) return;

  function handleClick(btn) {

    var card = list.querySelector('.s-featured__card');

    if (!card) return;

    var styles = window.getComputedStyle(list);

    var gap = parseInt(styles.columnGap || styles.gap || 0, 10);

    var cardsPerView = 4;

    var scrollAmount =
      (card.offsetWidth + gap) * cardsPerView;

    list.scrollBy({
      left: btn.classList.contains('is-next')
        ? scrollAmount
        : -scrollAmount,
      behavior: 'smooth',
    });

    setTimeout(function () {
      updateFeaturedNav(section);
    }, 400);
  }

  prevBtn.addEventListener('click', function() {
    handleClick(prevBtn);
  });

  nextBtn.addEventListener('click', function() {
    handleClick(nextBtn);
  });

}

/* =====================================================
   FEATURED INTERNAL FILTERS
===================================================== */

function normalizeFeaturedValue(value) {
  return String(value || '')
    .trim()
    .toLowerCase();
}

function getActiveFeaturedFilters(section) {
  var filters = {
    line: [],
    protein: [],
    weight: []
  };

  var checkedInputs = section.querySelectorAll(
    '[data-featured-filters-form] .digi-search-filters__checkbox:checked'
  );

  checkedInputs.forEach(function (input) {
    var key = input.getAttribute('data-filter-key');
    var value = normalizeFeaturedValue(input.value);

    if (!key || !value) return;

    if (!filters[key]) {
      filters[key] = [];
    }

    filters[key].push(value);
  });

  return filters;
}

function matchesFeaturedFilters(card, filters) {
  var line = normalizeFeaturedValue(card.getAttribute('data-line'));
  var protein = normalizeFeaturedValue(card.getAttribute('data-protein'));
  var weight = normalizeFeaturedValue(card.getAttribute('data-weight'));

  if (filters.line.length && !filters.line.includes(line)) {
    return false;
  }

  if (filters.protein.length && !filters.protein.includes(protein)) {
    return false;
  }

  if (filters.weight.length && !filters.weight.includes(weight)) {
    return false;
  }

  return true;
}

function updateFeaturedFilterCount(section, visibleCount) {
  var countEl = section.querySelector('[data-featured-count]');

  if (!countEl) return;

  countEl.textContent =
    visibleCount === 1
      ? '1 produto'
      : visibleCount + ' produtos';
}

function applyFeaturedFilters(section) {
  var cards = section.querySelectorAll('[data-featured-card]');
  var filters = getActiveFeaturedFilters(section);

  var visibleCount = 0;

  cards.forEach(function (card) {
    var isVisible = matchesFeaturedFilters(card, filters);

    card.hidden = !isVisible;

    if (isVisible) {
      visibleCount += 1;
    }
  });

  updateFeaturedFilterCount(section, visibleCount);

  var list = section.querySelector('.s-featured__list');

  if (list) {
    list.scrollLeft = 0;
  }

  updateFeaturedNav(section);
}

function initFeaturedFilters(section) {
  var form = section.querySelector('[data-featured-filters-form]');

  if (!form) return;

  form.addEventListener('change', function (event) {
    var target = event.target;

    if (!target.matches('.digi-search-filters__checkbox')) return;

    applyFeaturedFilters(section);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.s-featured').forEach(function (section) {
    initQuickAdd(section);
    initReveal(section);
    initCouponCopy(section);
    initSecondaryImages(section);
    initCarouselNav(section);
    initFeaturedFilters(section);

    var list = section.querySelector('.s-featured__list');

    if (list) {
      list.scrollLeft = 0;
    }

    updateFeaturedNav(section);

    var list = section.querySelector('.s-featured__list');

    if (list) {
      list.addEventListener('scroll', function () {
        updateFeaturedNav(section);
      });

      window.addEventListener('resize', function () {
        updateFeaturedNav(section);
      });
    }
  });
});

})();


